import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/fields/$fieldId/rx')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
